import React from "react";
import { NavItem, NavLink, Badge, Collapse, DropdownItem } from "shards-react";
import moment from "moment"; // Import moment.js for date formatting
export default class Notifications extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: false,
      notifications: [], // Store notifications from the API
      loading: true, // Loading state
      error: null, // Error state
    };

    this.toggleNotifications = this.toggleNotifications.bind(this);
  }

  componentDidMount() {
    // Fetch notifications when the component mounts
    this.fetchNotifications();
  }

  toggleNotifications() {
    this.setState((prevState) => ({
      visible: !prevState.visible,
    }));
  }

  async fetchNotifications() {
    const url = "https://vaptlabreport.com/shieldapi/top5issues.php";

    // Retrieve company_id from localStorage
    const company_id = localStorage.getItem("company_id");

    if (!company_id) {
      this.setState({ error: null, loading: false }); // No error shown
      return;
    }

    const requestBody = { company_id };

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        throw new Error("Failed to fetch notifications");
      }

      const data = await response.json();
      
      // Validate the data from API
      if (!data || !Array.isArray(data.data) || data.data.length === 0) {
        this.setState({ notifications: [], loading: false, error: null }); // No error shown
        return;
      }

      this.setState({ notifications: data.data, loading: false, error: null });
    } catch (error) {
      console.error("Error fetching notifications:", error);
      this.setState({ error: null, loading: false }); // No error shown
    }
  }

  render() {
    const { visible, notifications, loading } = this.state;

    return (
      <NavItem className="border-right dropdown notifications">
        <NavLink
          className="nav-link-icon text-center"
          onClick={this.toggleNotifications}
        >
          <div className="nav-link-icon__wrapper">
            <i className="material-icons">&#xE7F4;</i>
            <Badge pill theme="danger">
              {notifications.length}
            </Badge>
          </div>
        </NavLink>
        <Collapse
          open={visible}
          className="dropdown-menu dropdown-menu-small"
        >
          {loading && (
            <DropdownItem>
              <p>Loading notifications...</p>
            </DropdownItem>
          )}
          {!loading && notifications.length > 0 ? (
            <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
              {notifications.map((notification, index) => {
                // Filter detections that have a "YES"/true value (1 in this case)
                const validDetections = Object.entries(notification.detections).filter(
                  ([key, value]) => value === 1
                );

                return (
                  <DropdownItem key={index}>
                    <div className="notification__icon-wrapper">
                      <div className="notification__icon">
                        <i className="material-icons">&#xE6E1;</i>
                      </div>
                    </div>
                    <div className="notification__content">
                      <span className="notification__category">
                        Device: <a href={`/devicedetails?uuid=${notification.device_id}`} target="_self" rel="noopener noreferrer">{notification.device_id}</a>
                      </span>
                      <p>
                        <strong>Device Score: {notification.device_score}</strong>
                      </p>
                      <p>
                        <strong>Detected Issues:</strong>
                      </p>
                      <ul>
                        {validDetections.map(([key, value]) => (
                          <li key={key}>
                            <strong>{key.replace(/([A-Z])/g, ' $1')}: </strong>
                            <span className="text-danger">YES</span>
                          </li>
                        ))}
                      </ul>
                      <p> Date: {moment(notification.detection_date).format('YYYY-MM-DD hh:mm A')}</p>
                    </div>
                  </DropdownItem>
                );
              })}
            </div>
          ) : (
            <DropdownItem>
              <p>No new notifications.</p>
            </DropdownItem>
          )}
        </Collapse>
      </NavItem>
    );
  }
}

